import $ from "jquery";

export const TRANSITION_TYPE = {
    slide: "slide",
    fade: "fade"
};

export const ANIMATION_SPEED = 400;

export function getSLIDE_DOWN_UP(speedMultiplier) {
    const speed = speedMultiplier * ANIMATION_SPEED;
    return {
        enter(el, done) {
            const $el = $(el);
            if ($el.is(":animated")) {
                $el.slideDown(speed, done);
            } else {
                $el.hide().slideDown(speed, done);
            }
        },
        leave(el, done) {
            $(el).slideUp(speed, done);
        }
    };
}
export const SLIDE_DOWN_UP = getSLIDE_DOWN_UP(1);

export function getFADE_IN_OUT(speedMultiplier) {
    const speed = speedMultiplier * ANIMATION_SPEED;
    return {
        enter(el, done) {
            const $el = $(el);
            if ($el.is(":animated")) {
                $el.fadeIn(speed, done);
            } else {
                $el.hide().fadeIn(speed, done);
            }
        },
        leave(el, done) {
            $(el).fadeOut(speed, done);
        }
    };
}
export const FADE_IN_OUT = getFADE_IN_OUT(1);
